export const GET_BROADCAST_BANNER = "GET_BROADCAST_BANNER";
export const CREATE_NEW_BROADCAST_BANNER = "CREATE_NEW_BROADCAST_BANNER";
export const EDIT_BROADCAST_BANNER = "EDIT_BROADCAST_BANNER";
export const DELETE_BROADCAST_BANNER = "DELETE_BROADCAST_BANNER";

export const BROADCAST_BANNER_VIP_SWITCH = "BROADCAST_BANNER_VIP_SWITCH";

export const OPEN_BROADCAST_BANNER_DIALOG = "OPEN_BROADCAST_BANNER_DIALOG";
export const CLOSE_BROADCAST_BANNER_DIALOG = "CLOSE_BROADCAST_BANNER_DIALOG";
